import { defineMessages, makeMessages } from "features/localisation";

const messages = makeMessages({
  message: {
    id: "teacher.signUp.firstClassName",
    defaultMessage: "{nickname}'s class"
  }
});

export { messages };
export default defineMessages(messages);
